
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"60","height":"60"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M56.84 3.32S59.05 13.45 55.1 19 19.2 50.14 13.65 54.1c-2.51 1.79-5.56 2.35-7.75.16s-1.79-5.4 0-7.91C9.86 40.8 35.47 8.86 41 4.9s15.84-1.58 15.84-1.58z","fill":"none","stroke":"#241f21","stroke-miterlimit":"10","stroke-width":"2"}}),_c('path',{attrs:{"d":"M50.58 16.54a6.36 6.36 0 00-1.8-5.3h0a6.36 6.36 0 00-5.3-1.8M12.72 37.68C12.6 37.7 5 34.23 5 34.23L1.5 37.7l6.73 6.73M22.32 47.28c0 .12 3.45 7.75 3.45 7.75L22.3 58.5l-6.73-6.73M33.99 12.9L11.21 1.5 5.67 7.04l18.01 18.01M47.1 26.01l11.4 22.78-5.54 5.54-18.01-18","fill":"none","stroke":"#241f21","stroke-miterlimit":"10","stroke-width":"2"}})])
          )
        }
      }
    